import _ from 'lodash' // eslint-disable-line no-undef

export default function (agents, agentId) {
  var agentName = '-'
  agents.map(function (agent) {
    if (agent.meta.id === agentId) {
      agentName = agent.firstname + ' ' + agent.lastname
    }
  })
  return agentName
}




// WEBPACK FOOTER //
// ./src/utils/agentNameFormatter.js